var array = Array.prototype;

export var slice = array.slice;
export var map = array.map;



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-array/src/array.js
// module id = 46
// module chunks = 0